import { createInsuranceProductPreset } from '../common/productPresetFactory'

const COPY_BY_PRESET = {
  default: {
    heroTitle: '장기 돌봄 비용과 가족 부담을 기준으로 간병보험을 검토합니다',
    heroSubtitle: '간병 상태, 지급 조건, 가족의 돌봄 공백까지 함께 확인해 상담 방향을 정리합니다.',
    formTitle: '간병보험 상담 신청',
  },
  'clean-form': {
    heroTitle: '간병 대비, 지급 조건과 가족 부담을 먼저 확인하세요',
    heroSubtitle: '장기 간병 비용과 돌봄 공백을 중심으로 필요한 보장을 상담합니다.',
    formTitle: '간병 보장 상담',
  },
  'hanwha-sections': {
    heroTitle: '장기 돌봄 위험과 가족 부담을 함께 보는 간병보험 안내',
    heroSubtitle: '치료 이후 생활비와 돌봄 부담까지 함께 보고 필요한 대비를 정리해드립니다.',
    formTitle: '간병보험 상담 신청',
  },
  'basic-template-4': {
    heroTitle: '치료 이후의 생활까지 고려한 간병 대비를 시작하세요',
    heroSubtitle: '장기 간병 리스크와 가족 부담 포인트를 먼저 확인하고 대비 방향을 안내해드립니다.',
    formTitle: '대비 방향 점검',
  },
  'basic-template-5': {
    heroTitle: '미래 돌봄 리스크를 체계적으로 준비하는 간병보험',
    heroSubtitle: '장기 비용, 가족 부담, 핵심 특약까지 현재 상황에 맞춰 차분하게 안내해드립니다.',
    formTitle: '1:1 간병 상담',
  },
}

export function getProductCarePreset(presetKey = 'default') {
  const copy =
    COPY_BY_PRESET[presetKey]
    || (presetKey === 'lead-gen-fullbleed' ? COPY_BY_PRESET['hanwha-sections'] : undefined)
    || COPY_BY_PRESET.default
  return createInsuranceProductPreset('PRODUCT_CARE', copy, presetKey)
}
